// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProjectDisplay_wrapper__RwkF8"};